import React, { Component } from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import "../../CSS/DinaCode.css";
import festival1 from '../../MyFiles/Festival/Festival1.png';
import festival2 from '../../MyFiles/Festival/Festival3.png';
import festival3 from '../../MyFiles/Festival/Festival2.png';
import Lottery from "./Festival/Lottery";
import Wheel from "./Festival/Wheel";
import Loyalty from "./Festival/Loyalty";

class DinaCode extends Component {

    state = {
        coins: 0,
        lotteries: [],
        lotteryCodes: [],
        totalOrders: 0,
        availableChances: 0,
        ordersInCurrentCycle: 0,
        bonusChances: 0,
        canSpin: false,
        orderRewards: [],
        loading: false,
    };

    festivals = [
        {
            id: 1,
            title: "جشنواره قرعه‌کشی",
            description: "قرعه‌کشی و شانس برنده شدن ۳ جایزه نفیس",
            image: festival1,
            route: "/dina-code/lottery"
        },
        {
            id: 2,
            title: "گردونه شانس",
            description: "گردون را بچرخانید و شانس خوهد را امتحان کنید",
            image: festival2,
            route: "/dina-code/wheel"
        },
        {
            id: 3,
            title: "جایزه وفاداری",
            description: "به پاس همراهی شما، یک جایزه ویژه",
            image: festival3,
            route: "/dina-code/loyalty"
        }
    ];

    componentDidMount() {
        this.getUserCoins();
        this.getLotteries();
        this.getLotteryCodes();
        this.getWheelStatus();
    }

    // ============ API Calls ============
    getUserCoins = () => {
        const token = localStorage.getItem("token");
        if (token === null) return;

        const formdata = new FormData();
        formdata.append("token", token);
        const requestOptions = {
            method: "POST",
            body: formdata,
            redirect: "follow",
        };
        fetch(`${process.env.REACT_APP_BASE_URL}/api/dina-code/user-coins`, requestOptions)
            .then((res) => res.text())
            .then((result) => {
                if (result !== null) {
                    const myObject = JSON.parse(result);
                    if (myObject.status === 0) {
                        this.setState({ coins: myObject.data.coins });
                    }
                }
            })
            .catch((err) => console.log("getUserCoins error", err));
    };
    getLotteries = () => {
        const token = localStorage.getItem("token");
        if (token === null) return;

        const formdata = new FormData();
        formdata.append("token", token);
        const requestOptions = {
            method: "POST",
            body: formdata,
            redirect: "follow",
        };

        fetch(`${process.env.REACT_APP_BASE_URL}/api/dina-code/lottery`, requestOptions)
            .then((res) => res.text())
            .then((result) => {
                if (result !== null) {
                    const myObject = JSON.parse(result);
                    if (myObject.status === 0) {
                        this.setState({ lotteries: myObject.data });
                    }
                }
            })
            .catch((err) => console.log("getLotteries error", err));
    };
    getLotteryCodes = () => {
        const token = localStorage.getItem("token");
        if (token === null) return;
        const formdata = new FormData();
        formdata.append("token", token);
        const requestOptions = {
            method: "POST",
            body: formdata,
            redirect: "follow",
        };
        fetch(`${process.env.REACT_APP_BASE_URL}/api/dina-code/user-lottery-codes`, requestOptions)
            .then((res) => res.text())
            .then((result) => {
                if (result !== null) {
                    const myObject = JSON.parse(result);
                    if (myObject.status === 0) {
                        this.setState({ lotteryCodes: myObject.data });
                    }
                }
            })
            .catch((err) => console.log("getLotteryCodes error", err));
    };
    handleJoinLottery = (lotteryId, coinCost) => {
        const token = localStorage.getItem("token");
        if (token === null) return;

        if (this.state.coins < coinCost) {
            if (this.props.toggleErrorMessage) {
                this.props.toggleErrorMessage("موجودی سکه شما کافی نیست.");
                this.props.toggleError();
            }
            return;
        }
        this.setState({ loading: true });

        const formdata = new FormData();
        formdata.append("token", token);
        formdata.append("lotteryId", lotteryId);
        const requestOptions = {
            method: "POST",
            body: formdata,
            redirect: "follow",
        };

        fetch(`${process.env.REACT_APP_BASE_URL}/api/dina-code/user-join-Lottery`, requestOptions)
            .then((res) => res.text())
            .then((result) => {
                this.setState({ loading: false });
                if (result !== null) {
                    const myObject = JSON.parse(result);
                    if (myObject.status === 0) {
                        this.setState((prevState) => ({
                            coins: myObject.data.balanceAfter,
                            lotteryCodes: [myObject.data, ...prevState.lotteryCodes],
                        }));
                        if (this.props.toggleErrorMessage) {
                            this.props.toggleErrorMessage(
                                `کد قرعه‌کشی شما: ${myObject.data.code}`
                            );
                            this.props.toggleError();
                        }
                    } else {
                        if (this.props.toggleErrorMessage) {
                            this.props.toggleErrorMessage(
                                myObject.message || "خطا در دریافت کد"
                            );
                            this.props.toggleError();
                        }
                    }
                }
            })
            .catch((err) => {
                this.setState({ loading: false });
                console.log("joinLottery error", err);
            });
    };

    getWheelStatus = () => {
        const token = localStorage.getItem("token");
        if (token === null) return;

        const formdata = new FormData();
        formdata.append("token", token);
        const requestOptions = { method: "POST", body: formdata, redirect: "follow" };

        fetch(`${process.env.REACT_APP_BASE_URL}/api/dina-code/get-wheel-status`, requestOptions)
            .then((res) => res.text())
            .then((result) => {
                if (result !== null) {
                    const myObject = JSON.parse(result);
                    if (myObject.status === 0) {
                        this.setState({
                            totalOrders: myObject.data.totalOrders,
                            availableChances: myObject.data.availableChances,
                            ordersInCurrentCycle: myObject.data.ordersInCurrentCycle,
                            bonusChances: myObject.data.bonusChances,    // ← جدید
                            canSpin: myObject.data.canSpin,
                            coins: myObject.data.currentBalance,
                        });
                    }
                }
            })
            .catch((err) => console.log("getWheelStatus error", err));
    };
    getOrderRewards = () => {
        const token = localStorage.getItem("token");
        if (token === null) return;

        const formdata = new FormData();
        formdata.append("token", token);
        const requestOptions = { method: "POST", body: formdata, redirect: "follow" };

        fetch(`${process.env.REACT_APP_BASE_URL}/api/dina-code/getOrderRewards`, requestOptions)
            .then((res) => res.text())
            .then((result) => {
                if (result !== null) {
                    const myObject = JSON.parse(result);
                    if (myObject.status === 0) {
                        this.setState({ orderRewards: myObject.data });
                    }
                }
            })
            .catch((err) => console.log("getOrderRewards error", err));
    };
    handleSpinWheel = (onSuccess) => {
        const token = localStorage.getItem("token");
        if (token === null) return;

        this.setState({ loading: true });

        const formdata = new FormData();
        formdata.append("token", token);
        const requestOptions = { method: "POST", body: formdata, redirect: "follow" };

        fetch(`${process.env.REACT_APP_BASE_URL}/api/dina-code/spin-wheel`, requestOptions)
            .then((res) => res.text())
            .then((result) => {
                this.setState({ loading: false });
                if (result !== null) {
                    const myObject = JSON.parse(result);
                    if (myObject.status === 0) {
                        this.getWheelStatus();
                        if (onSuccess) onSuccess(myObject.data);
                    } else {
                        if (this.props.toggleErrorMessage) {
                            this.props.toggleErrorMessage(myObject.message || "خطا در چرخش");
                            this.props.toggleError();
                        }
                        if (onSuccess) onSuccess(null);
                    }
                }
            })
            .catch((err) => {
                this.setState({ loading: false });
                console.log("spinWheel error", err);
                if (onSuccess) onSuccess(null);
            });
    };

    // ============ UI ============
    handleFestivalClick = (route) => {
        this.props.history.push(route);
    };
    renderFestivals = () => (
        <div className="dina-code-page body-padding">
            <div className="dina-code-header pt-3">
                <h3>طرح‌های فعال دینا کد</h3>
                <p>یکی از طرح‌های زیر را انتخاب کنید و شانس خود را امتحان کنید.</p>
            </div>

            <div className="dina-code-festivals">
                {this.festivals.map((festival) => (
                    <div
                        key={festival.id}
                        className="festival-card"
                        onClick={() => this.handleFestivalClick(festival.route)}
                    >
                        <div className="festival-image-wrapper">
                            <img
                                src={festival.image}
                                alt={festival.title}
                                className="festival-image"
                            />
                        </div>

                        <div className="festival-content">
                            <h4>{festival.title}</h4>
                            <p>{festival.description}</p>

                            <button type="button">
                                ورود به جشنواره
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
    render() {
        return (
            <Switch>
                <Route path="/dina-code" exact>
                    {this.renderFestivals()}
                </Route>

                <Route path="/dina-code/lottery">
                    <Lottery
                        coins={this.state.coins}
                        lotteries={this.state.lotteries}
                        codes={this.state.lotteryCodes}
                        loading={this.state.loading}
                        onJoinLottery={this.handleJoinLottery}
                        onBack={() => this.props.history.push("/dina-code")}
                    />
                </Route>

                <Route path="/dina-code/wheel">
                    <Wheel
                        totalOrders={this.state.totalOrders}
                        availableChances={this.state.availableChances}
                        ordersInCurrentCycle={this.state.ordersInCurrentCycle}
                        bonusChances={this.state.bonusChances}
                        canSpin={this.state.canSpin}
                        orderRewards={this.state.orderRewards}
                        loading={this.state.loading}
                        onRequestOrders={this.getOrderRewards}
                        onRefreshStatus={this.getWheelStatus}
                        onSpinWheel={this.handleSpinWheel}
                        toggleError={this.props.toggleError}
                        toggleErrorMessage={this.props.toggleErrorMessage}
                    />
                </Route>

                <Route path="/dina-code/loyalty">
                    <Loyalty
                        toggleError={this.props.toggleError}
                        toggleErrorMessage={this.props.toggleErrorMessage}
                    />
                </Route>
            </Switch>
        );
    }
}

export default withRouter(DinaCode);